export const intentLibrary = [
  {
    id: 'raise_issue',
    entityType: 'issue',
    triggers: [
      'raise an issue', 'report a problem', 'log an issue', 'flag a problem', 'create issue',
      'had a problem', 'something went wrong', 'report something'
    ],
    response: "I'd be happy to help you document this issue! To get started, could you describe what's happening? The more details you can provide, the better I can assist you.",
    confirmation: "log an issue",
    extractors: {
      severity: /(high|medium|low)/i,
      department: /(it|compliance|finance)/i,
      urgency: /(urgent|asap|immediate)/i
    }
  },
  {
    id: 'create_risk',
    entityType: 'risk',
    triggers: [
      'identify a risk', 'log a risk', 'raise a risk', 'new risk', 'potential risk',
      'emerging risk', 'risk exposure'
    ],
    response: "I'd love to help you document this risk! Let's make sure we capture all the important details.",
    confirmation: "create a risk"
  },
  {
    id: 'report_incident',
    entityType: 'incident',
    triggers: [
      'report an incident', 'incident occurred', 'security incident', 'data breach', 'outage',
      'operational incident', 'cyber incident'
    ],
    response: "I'm here to help you report this incident. Let's make sure we document everything accurately.",
    confirmation: "report an incident"
  },
  {
    id: 'define_control',
    entityType: 'control',
    triggers: [
      'add a control', 'define control', 'log a control', 'new control needed', 'missing control'
    ],
    response: "I'd be happy to help you define this control! Let's work together to set it up properly.",
    confirmation: "define a control"
  },
  {
    id: 'review_compliance',
    entityType: 'compliance',
    triggers: [
      'regulatory gap', 'compliance concern', 'audit finding', 'compliance issue', 'law', 'regulation'
    ],
    response: "I'd love to help you review this compliance topic! Let's make sure we cover all the requirements.",
    confirmation: "review a compliance topic"
  }
]; 